export default __webpack_public_path__ + "static/media/BeVietnam-Regular.bc288a53.ttf";